import RelatedDetail from '../../../related/_detail';

// Related site detail (EN). Copy and images: src/data/related/butler-academy.ts; FAQ: src/data/faq.json (/en/related/butler-academy).
export default function EnRelatedButlerAcademyPage() {
  return <RelatedDetail slug="butler-academy" lang="en" />;
}
